import { useMemo } from 'react'

import { createColumnHelper } from '@tanstack/react-table'

import { Hash, AirdropItem } from 'types/entities'

import { useToken, useRecipientsList } from 'state/airdrop/hooks'

import { sliceHash } from 'utils/stringUtils'
import { fromWei, toWei } from 'utils/crypto'

import { Slash, Table } from 'components/ui'

import { Amount, TableWrap, LabelTitle, DesktopPecipient, MobilePecipient } from './Style'

export function RecipientsTable() {
  const token = useToken()
  const recipientsList = useRecipientsList()

  const tableData = useMemo(() => {
    const numDecimals = Number(token?.decimals.toString())
    return recipientsList.map((el) => ({ ...el, amount: toWei(el.amount, numDecimals) }))
  }, [recipientsList, token])

  const recipientsCount = useMemo(() => {
    return recipientsList.reduce<Hash[]>((acc, curr) => (acc.includes(curr.addr) ? acc : acc.concat(curr.addr)), [])
      .length
  }, [recipientsList])

  const columnHelper = createColumnHelper<AirdropItem>()

  const columns = useMemo(
    () => [
      columnHelper.accessor('addr', {
        header: 'recipient',
        cell: (data) => {
          return (
            <>
              <MobilePecipient>{sliceHash(data.getValue())}</MobilePecipient>
              <DesktopPecipient>{data.getValue()}</DesktopPecipient>
            </>
          )
        },
      }),
      columnHelper.accessor('amount', {
        header: 'amount',
        cell: (data) => {
          return (
            <Amount>
              {fromWei(data.getValue().toString(), token?.decimals)} {token?.symbol}
            </Amount>
          )
        },
      }),
    ],
    [token, recipientsList],
  )

  return (
    <>
      <LabelTitle>
        <Slash />
        _list-of-recipients ({recipientsCount})
      </LabelTitle>

      <TableWrap>
        <Table<AirdropItem> name='recipientTable' isStickyHeader columns={columns} data={tableData} />
      </TableWrap>
    </>
  )
}
